import Dialog, {
  DialogBody,
  DialogButtonRow,
  DialogCancelButton,
  DialogDestructiveButton,
} from '../Dialog';

const RemoveCarConfirmationDialog = ({ open, onClose, onConfirm, carName }) => {
  const handleConfirm = () => {
    onConfirm?.();
    onClose();
  };

  return (
    <Dialog
      open={open}
      closable={false}
      onClose={onClose}
      title="SUPPRIMER LE VÉHICULE ?"
      slotProps={{
        title: {
          sx: {
            marginBottom: '12px',
            textAlign: 'center',
          },
        },
      }}
      PaperProps={{ sx: { width: 400 } }}
    >
      <DialogBody>
        {carName
          ? `Êtes-vous sûr de vouloir supprimer ${carName} de la liste ?`
          : 'Êtes-vous sûr de vouloir supprimer ce véhicule de la liste ?'}
      </DialogBody>
      <DialogButtonRow>
        <DialogCancelButton variant="contained" onClick={onClose}>
          ANNULER
        </DialogCancelButton>
        <DialogDestructiveButton variant="contained" onClick={handleConfirm}>
          SUPPRIMER
        </DialogDestructiveButton>
      </DialogButtonRow>
    </Dialog>
  );
};

export default RemoveCarConfirmationDialog;
